import React, { useState } from "react";
import Modal from "../../elements/Modal";
import Button from "../../form/Button";
import ChartEditEmployee from "./ChartEditEmployee";

export default function DepartmentConfirmModal({
  editNode,
  setModalState = () => {},
  modalState,
  customMessage,
  loading = false,
  onClose = () => {},
  title = "Employee",
  setEmpDetails = () => {},
  setSidePanelOpen = () => {},
  loadDeplist = () => {},
}) {
  const data = modalState?.data;
  const [duplicate, setDuplicate] = useState("");
  const [assignedEmployee, setAssignedEmployee] = useState({
    isOpen: false,
  });

  const handleSubmit = async (departments = []) => {
    if (typeof editNode !== "function") {
      console.error("editNode is not a function");
      return;
    }

    try {
      const payload = {
        userId: data?.userId,
        ...(data?.positionId && { positionId: data.positionId }),
        editUser: true,
        ...departments.reduce((acc, deptId, i) => {
          acc[`departmentId[${i}]`] = deptId;
          return acc;
        }, {}),
        userAssignType: duplicate,
      };

      const res = await editNode(payload);

      if (res?.status === 200) {
        setModalState((prev) => ({ ...prev, isOpen: false }));

        setSidePanelOpen((prev) => ({
          ...prev,
          isOpen: true,
          _id: res?.data?._id,
        }));
        loadDeplist();
        setEmpDetails((pre) => ({ ...pre, data: res?.data }));
      } else {
        setEmpDetails((prev) => ({ ...prev, loading: false }));
        setModalState((prev) => ({ ...prev, isOpen: false }));
      }
    } catch (error) {
      console.error("Department update failed:", error);
      setEmpDetails((prev) => ({ ...prev, loading: false }));
      setModalState((prev) => ({ ...prev, isOpen: false }));
    }
  };

  return (
    <Modal
      open={modalState?.isOpen}
      onClose={() => {
        onClose();
        setModalState((prev) => ({ ...prev, isOpen: false }));
      }}
      title={title}
      size="xl"
      modaltitleClasses="!text-slate-200 text-lg"
      headerClass="!bg-black !rounded-t-lg !text-white"
      childrenClasses="!rounded-b-lg"
    >
      <div className="p-3">
        <div className="text-center text-orange-600 font-semibold">
          {customMessage ? (
            customMessage
          ) : (
            <>
              Are you certain you'd like to proceed with changing your
              department?
            </>
          )}
        </div>

        <div className="flex gap-4 justify-end mt-5">
          <Button
            buttonIconPosition="left"
            buttonIcon="fa-regular fa-close"
            buttonLabel="Cancel"
            buttonFunction={() => {
              onClose();
              setModalState((prev) => ({ ...prev, isOpen: false }));
            }}
            buttonClasses="bg-slate-50 border-red-500 !text-slate-500"
          />

          <Button
            buttonFunction={() => {
              if (modalState?.isChartEditModal) {
                let departments = modalState?.newOnly;
                setAssignedEmployee({
                  isOpen: true,
                  payload: {
                    userId: data?.userId,
                    ...(data?.positionId && { positionId: data.positionId }),
                    editUser: true,
                    ...departments.reduce((acc, deptId, i) => {
                      acc[`departmentId[${i}]`] = deptId;
                      return acc;
                    }, {}),
                    userAssignType: duplicate,
                  },
                });
              } else {
                handleSubmit(modalState?.newOnly);
              }
            }}
            buttonIconPosition="left"
            buttonIcon={
              loading
                ? "fa-duotone fa-spinner-third animate-spin"
                : "fa-regular fa-undo"
            }
            buttonLabel="Replace Departments"
            buttonClasses="bg-orange-500 border-orange-500"
            loading={loading}
          />

          <Button
            buttonFunction={() => {
              if (modalState?.isChartEditModal) {
                let departments = modalState?.newDepartments;
                setAssignedEmployee({
                  isOpen: true,
                  payload: {
                    userId: data?.userId,
                    ...(data?.positionId && { positionId: data.positionId }),
                    editUser: true,
                    ...departments.reduce((acc, deptId, i) => {
                      acc[`departmentId[${i}]`] = deptId;
                      return acc;
                    }, {}),
                    userAssignType: duplicate,
                  },
                });
              } else {
                handleSubmit(modalState?.newDepartments);
              }
            }}
            buttonIconPosition="left"
            buttonIcon={
              loading
                ? "fa-duotone fa-spinner-third animate-spin"
                : "fa-solid fa-plus"
            }
            buttonLabel="Add to Departments"
            buttonClasses="bg-orange-500 border-orange-500"
            loading={loading}
          />
        </div>
      </div>
      <ChartEditEmployee
        editNode={editNode}
        setAssignedEmployee={setAssignedEmployee}
        assignedEmployee={assignedEmployee}
        setEmpDetails={setEmpDetails}
        setSidePanelOpen={setSidePanelOpen}
        isApiCall={false}
        setDuplicate={setDuplicate}
        departmentConfirmModal={modalState?.isChartEditModal}
        setModalState={setModalState}
      />
    </Modal>
  );
}
